import { useState, useEffect, useRef, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import chatbotApi from '../../../services/chatbotApi';
import * as S from './styles';
import CatalogProductCard from '../../../components/ChatbotCatalog/CatalogProductCard';
import Loading from '../../../commons/Loading';
import CatalogBreadcrumb from '../../../components/ChatbotCatalog/CatalogBreadcrumb';
import CatalogCart from '../../../components/ChatbotCatalog/CatalogCart';
import CatalogBackToTop from '../../../components/ChatbotCatalog/CatalogBackToTop';
import { useInfiniteScroll } from '../../../hooks/useInfiniteScroll';
import { useTitle } from '../../../hooks/useTitle';
import EmptyPage from '../../../components/EmptyPage';

const CatalogCategoryDetail = () => {
  const { id } = useParams();
  const [category, setCategory] = useState({})
  const [products, setProducts] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isInitialLoading, setIsInitialLoading] = useState(true);
  const [isFetchingMore, setIsFetchingMore] = useState(false);

  const getCategory = async () => {
    const response = await chatbotApi.get(`/api/v2/Category/${id}`)
    setCategory(response.data.response.data)
  }

  const getProducts = useCallback(async () => {
    if (isFetchingMore || page > totalPages) return;

    setIsFetchingMore(true);
    try {
      const response = await chatbotApi.get(`/api/v2/Chatbot/ProductsByCategory?CategoryId=${id}&OnlyB2B=true&Page=${page}&Size=5`);
      const { data, totalPages: responseTotalPages } = response.data.response;

      setTotalPages(responseTotalPages);

      if (data.length === 0) {
        setHasMore(false);
      } else {
        setProducts(prev => page === 1 ? data : [...prev, ...data]);
        setPage(prev => prev + 1);

        if (page >= responseTotalPages) {
          setHasMore(false);
        }
      }
    } catch (error) {
      console.error('Error fetching products:', error);
      setHasMore(false);
    } finally {
      setIsFetchingMore(false);
      setIsInitialLoading(false);
    }
  }, [id, page, isFetchingMore, totalPages]);

  const loaderRef = useInfiniteScroll({
    onEndReached: getProducts,
    isLoading: isFetchingMore,
    hasMore,
  });

  useEffect(() => {
    setProducts([]);
    setPage(1);
    setTotalPages(1);
    setHasMore(true);
    setIsInitialLoading(true);
    setIsFetchingMore(false);

    getCategory()
  }, [id]);

  useTitle(category.description);

  return (
    <S.CategoryDetail>
      <CatalogBreadcrumb
        // current={} oode ser usado para subcategorias
        parent={category.description}
      />
      {!isInitialLoading && products.length > 0 && 
        <S.CategoryGridProducts>
          {products.map((product) => (
            <CatalogProductCard key={product.id} product={product} isCategoryPage />
          ))}
        </S.CategoryGridProducts>
      }
      {!isInitialLoading && products.length === 0 &&
        <EmptyPage message="Nenhum produto encontrado nesta categoria" />
      }
      <CatalogCart />
      <div ref={loaderRef} style={{ height: '1px' }} />
      {isFetchingMore && (
        <S.LoadingWrapper>
          <Loading />
        </S.LoadingWrapper>
      )}
      <CatalogBackToTop />
    </S.CategoryDetail>
  );
};

export default CatalogCategoryDetail;